export enum EnumTipoDocumentoAuditoria {
    CargadoInforme = 1,
    AspectoAsignado = 2
  }
  